import { Pipe, PipeTransform } from '@angular/core';
import { CloudinaryTransformPipe } from './cloudinary-transform.pipe';

@Pipe({ name: 'cloudinaryImageTransform' })
export class CloudinaryImageTransformPipe extends CloudinaryTransformPipe implements PipeTransform {
	type: 'video' | 'image' = 'image';
}
